var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11 27h14v6h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 33v6c0 .552.448 1 1 1h1v-8h-1c-.552 0-1 .448-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 39h-14v6h14zm-10 4h-2v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 20,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 19h14v2h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 15h-56c-.552 0-1 .448-1 1v9h2v8h-2v2h2v8h-2v5c0 .552.448 1 1 1h56c.552 0 1-.448 1-1v-32c0-.552-.448-1-1-1zm-8 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm-8 0c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm-8 0c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm-29 30h-2v-2h2zm0-28h-2v-2h2zm20 28h-18v-10h18zm0-12h-18v-10h18zm0-12h-18v-6h18zm32 24h-2v-2h2zm0-8c0 1.654-1.346 3-3 3h-1v1.414l-3.586 3.586h-10.828l-3.586-3.586v-1.414h-1c-1.654 0-3-1.346-3-3v-6c0-1.654 1.346-3 3-3h1v-1.414l3.586-3.586h10.828l3.586 3.586v1.414h1c1.654 0 3 1.346 3 3zm0-20h-2v-2h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 32h-1v8h1c.552 0 1-.448 1-1v-6c0-.552-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.414 27-2.414 2.414v13.172l2.414 2.414h9.172l2.414-2.414v-13.172l-2.414-2.414zm9.586 16h-10v-14h10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 31h6v10h-6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m2.2bac98d63dbd80aaf566697b893d7b6a.svg";
export { ForwardRef as ReactComponent };